import { GET_TEAM_ELIGIBLE_MEMBERS } from 'actions/Types';

export default (state = [], action) => {
  if (action.type === `${GET_TEAM_ELIGIBLE_MEMBERS}_SUCCESS`) {
    return action.payload;
  }

  return state;
};
